function logout () {
    for (let i in localStorage) {
        if (i.substring(0,1) !== '_') {
            localStorage.removeItem(i)
        }
    }
    window.location.replace('/login')
} 

export default logout